import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Testimonials } from '@/sections/Testimonials';
import React from 'react';
import { Button } from '@/components/buttons';
import { EXTERNAL_LINKS } from '@/constants/links';
import { Testimonial } from '@/api/sanity/testimonials';
export function TestimonialsGoogle(t0) {
  const $ = _c(12);
  const {
    testimonials
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["testimonials"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("categories.google.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = EXTERNAL_LINKS();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = t3.googleTestimonials;
  let t5;
  if ($[4] !== t) {
    t5 = t("categories.google.cta");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <Button variant="secondary" testId="testimonialsGoogle" analyticsParam="testimonialsGoogle" to={t4} size="lg" align="center">{t5}</Button>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t6 || $[10] !== testimonials) {
    t7 = <Testimonials anchorKey="testimonials.categories.google.title" title={t2} testimonials={testimonials} buttons={t6} />;
    $[8] = t2;
    $[9] = t6;
    $[10] = testimonials;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}